function getVolunteerBusinessId(type, newsTypeList) {
    var currentType = type === undefined || type === null || type === '' ? '0' : String(type)
    if (currentType === '0') {
        return '0'
    }

    var index = parseInt(currentType, 10) - 1
    if (String(index + 1) === currentType && newsTypeList && newsTypeList[index] && newsTypeList[index].id) {
        return newsTypeList[index].id
    }

    return currentType
}

function getVolunteerTitle(type, newsTypeList) {
    var currentType = type === undefined || type === null || type === '' ? '0' : String(type)
    if (currentType === '0') {
        return '热点新闻'
    }

    var index = parseInt(currentType, 10) - 1
    if (String(index + 1) === currentType && newsTypeList && newsTypeList[index] && newsTypeList[index].name) {
        return newsTypeList[index].name
    }

    return ''
}

function getVolunteerTabSign(type, newsTypeList) {
    var currentType = type === undefined || type === null || type === '' ? '0' : String(type)
    if (currentType === '0') {
        return 0
    }

    var index = parseInt(currentType, 10) - 1
    if (String(index + 1) === currentType && newsTypeList && newsTypeList[index]) {
        return index + 1
    }

    if (newsTypeList && newsTypeList.length) {
        for (var i = 0; i < newsTypeList.length; i++) {
            if (String(newsTypeList[i].id) === currentType) {
                return i + 1
            }
        }
    }

    return 0
}

function buildPictureItems(records, picture) {
    if (records && records.length > 0) {
        return records
    }

    if (picture && picture.breviaryMap) {
        return [{
            imgUrl: picture.breviaryMap,
            content: picture.pictureContent || picture.remark || '',
        }]
    }

    return []
}

module.exports = {
    buildPictureItems: buildPictureItems,
    getVolunteerBusinessId: getVolunteerBusinessId,
    getVolunteerTabSign: getVolunteerTabSign,
    getVolunteerTitle: getVolunteerTitle,
}
